import EditSpecDetailDescriptionContainer from "./EditSpecDetailDescriptionContainer";
export default EditSpecDetailDescriptionContainer;
